import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { Headers, Http, Response, RequestOptions, ResponseContentType } from '@angular/http';
import { AuthHttp } from "angular2-jwt/angular2-jwt";
import { ClienteLogin } from '../../../views/login/cliente_login';
import { ConstantService } from "../../../components/common/utils/constant.service";
import {Cliente} from "../../login/cliente_login";
import { SessionStorageService } from "ngx-webstorage";
import { VamTitularEntity, TitularVam } from './entities/vam_titulares_entity';
import { DocumentoTracking } from '../vam_entity';

declare var jQuery: any;
@Injectable()
export class VamTitularesService {
    usuario: ClienteLogin;
    private url="vamTittular";

    constructor(public authHttp: AuthHttp, private sessionStorageService: SessionStorageService) {
         let constantService = new ConstantService();
        this.url = constantService.API_ENDPOINT + this.url;
    }
    ConsultarDatosVamTitular(): Observable<VamTitularEntity> {
        this.usuario = jQuery.parseJSON(this.sessionStorageService.retrieve("usuario"));
        let body = JSON.stringify(this.usuario);
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization' : "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.post(this.url +"/consultarVamTit", body, options).map(this.extractData)
            .catch(this.handleError);
    }

    generarReporteImpuestoRenta(parametros: TitularVam): Observable<any> {
        let body = JSON.stringify(parametros);
        let headers = new Headers({
            'Content-Type': 'application/json',
            'Accept': 'application/pdf',
            'Authorization' : "Token " + sessionStorage.getItem("Token")
        });
        let options = new RequestOptions({ headers: headers });
        options.responseType = ResponseContentType.Blob;
        return this.authHttp.post(this.url + "/generarReporteImpuestoRenta/", body, options)
            .map(response => response).catch(this.handleError);
    }

    ActualizarVamTitular(titular:VamTitularEntity): Observable<boolean> {
      let body = JSON.stringify(titular);
      let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization' : "Token " + sessionStorage.getItem("Token") });
      let options = new RequestOptions({ headers: headers });
      return this.authHttp.post(this.url +"/actualizarVamTit", body, options).map(this.extractData)
          .catch(this.handleError);
  }


    private extractData(res: Response) {
        let body = res.json();
        return body || {};
    }
    private handleError(error: any) {
        return Observable.throw(error);
    }
}



// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/vam/titulares/vam-titulares.service.ts